import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { VuetifyOptions } from '@/external/telstra-ui-vue/plugins/vuetify-options';

Vue.use(Vuetify);

const opts = VuetifyOptions.options;

VuetifyOptions.options.breakpoint = {
    ...VuetifyOptions.options.breakpoint,
    thresholds: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
    },
};

export default new Vuetify(opts);
